import axios from "./api";

// 初始化协议内容
export const getInvoiceInfo = () => {
  return axios({
    url: "/v2/invoice/init",
    loading: true
  });
};

// 查询初始化
export const getTypeList = () => {
  return axios({
    url: "/v2/invoice/searchInit",
    loading: true
  });
};

// 验证手机验证码
export const checkPhone = data => {
  return axios({
    url: "/v2/invoice/checkSms",
    method: "post",
    data,
    loading: true,
    silent: [3001]
  });
};

// 获取订单
export const getOrder = data => {
  return axios({
    url: "/v2/invoice/searchOrder",
    method: "post",
    data,
    loading: true
  });
};

//所有未开票订单
export const getCanOrderInfo = data => {
  return axios({
    url: "/v2/invoice/allOrder",
    method: "post",
    data,
    loading: true
  });
};

//所有未开票订单
export const doOder = data => {
  return axios({
    url: "/v2/invoice/subWorksheet",
    method: "post",
    data,
    loading: true,
    silent: [3001]
  });
};
